export default {
  data: {
    id: "",
    govAuthStatus:"",
    govAuthStatusNote: ""
  },
  //type(Reg正则验证,Empty验证为空,MinMax验证数量区间)
  rule: {
    id: {
      type: "id",
      message: "审核参数丢失请刷新浏览器重新尝试",
    },
    govAuthStatus: {
      type: "Empty",
      message: "请选择审核情况",
    },
    govAuthStatusNote: {
      type: "Empty",
      message: "请输入审核理由",
    },
  },
};
